import { FC } from 'react';
import { Redirect, Route } from 'react-router-dom';
import useAuth from '../hooks/auth';
import { IRoute } from '../types';
import PermittedRoute from './permitted';

const ProtectedRoute: FC<IRoute> = (props) => {
  const { path, ...rest } = props; // eslint-disable-line @typescript-eslint/no-unused-vars
  const auth = useAuth();

  if (!auth.isAuthenticated)
    return (
      <Route
        {...rest}
        exact
        render={({ location }) => (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: location },
            }}
          />
        )}
      />
    );

  return <PermittedRoute exact {...props} />;
};

export default ProtectedRoute;
